import ModalFreeTrialExpired from './ModalFreeTrialExpired'

export default ModalFreeTrialExpired
// eslint-disable-next-line import/export
export * from './ModalFreeTrialExpired'
